/* Store locator – Little Cabari (v2 : tri par pays/ville, carte centrée, "Autour de moi") */
let mapDOM = document.getElementById("leafletMap");

class LeafletMap {
  constructor() {
    this.map = null;
    this.bounds = [];
    this.zoom = parseFloat(document.querySelector(".p_leaflet__map").dataset.zoom) || 12;
  }
  async load(element) {
    this.map = L.map(element, { scrollWheelZoom: false });
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors',
      maxZoom: 18,
      detectRetina: true
    }).addTo(this.map);
    this.map.attributionControl.setPrefix('<a href="https://leafletjs.com/" target="_blank">Leaflet</a>');
  }
  addMarker(lat, lng, img, name, address, phone) {
    const point = [lat, lng];
    this.bounds.push(point);
    return new LeafletMarker(this.map, point, img, name, address, phone);
  }
  /* Vue par défaut : l'Europe de l'Ouest (là où sont la majorité des boutiques),
     sans forcer un zoom fixe qui faisait tomber la carte dans l'Atlantique. */
  center() {
    const europe = this.bounds.filter(p => p[0] > 35 && p[0] < 60 && p[1] > -11 && p[1] < 20);
    const pts = europe.length ? europe : this.bounds;
    if (pts.length) this.map.fitBounds(pts, { padding: [30, 30], maxZoom: 12 });
    else this.map.setView([46.6, 2.4], 5);
  }
  fit(points) {
    if (points.length) this.map.fitBounds(points, { padding: [40, 40], maxZoom: 13 });
  }
  setView(lat, lng) {
    this.map.setView([lat, lng], this.zoom);
  }
}

class LeafletMarker {
  constructor(map, point, img = "", name = "", address = "", phone = "") {
    const imgContent = img ? `<img class="p_leaflet-popup__img" src="${img}">` : "";
    const nameContent = name ? `<span class="p_leaflet-popup__name">${name}</span>` : "";
    const addressContent = address ? `<span class="p_leaflet-popup__address">${address}</span>` : "";
    const phoneContent = phone ? `<span class="p_leaflet-popup__phone"><a href="tel:+${phone}">+${phone}</a></span>` : "";
    this.icon = L.divIcon({
      html: `<svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 24 24"><path fill="currentColor" d="M12.003 11.73q.668 0 1.14-.475q.472-.475.472-1.143t-.475-1.14q-.476-.472-1.143-.472t-1.14.476q-.472.475-.472 1.143t.475 1.14q.476.472 1.143.472M12 21.019q-3.525-3.117-5.31-5.814q-1.786-2.697-1.786-4.909q0-3.173 2.066-5.234Q9.037 3 12 3t5.030 2.062q2.066 2.061 2.066 5.234q0 2.212-1.785 4.909q-1.786 2.697-5.311 5.814"/></svg>`,
      className: "p_leaflet__marker-icon",
      iconSize: [32, 32]
    });
    this.popup = L.popup({ autoClose: true, closeOnEscapeKey: false, closeOnClick: false, closeButton: false, maxWidth: 200, className: "p_leaflet-popup" })
      .setContent(imgContent + nameContent + addressContent + phoneContent);
    this.marker = L.marker().setLatLng(point).setIcon(this.icon).bindPopup(this.popup).on("click", this.onClick).addTo(map);
  }
  onClick() {
    const ll = this.getLatLng();
    document.querySelectorAll(".js-leaflet-map-marker").forEach(item => {
      item.classList.remove("p_leaflet__item--active");
      if (parseFloat(item.dataset.lat) === ll.lat && parseFloat(item.dataset.lng) === ll.lng) {
        item.classList.add("p_leaflet__item--active");
        item.scrollIntoView({ block: "nearest", behavior: "smooth" });
      }
    });
  }
  setActive() {
    this.marker.openPopup();
    const el = this.popup.getElement();
    if (el) el.classList.add("p_leaflet__item--active");
  }
  unsetActive() {
    this.marker.closePopup();
    const el = this.popup.getElement();
    if (el) el.classList.remove("p_leaflet__item--active");
  }
}

/* ---------- Classement : showroom, puis pays > ville ---------- */
const LC_COUNTRIES = [
  ["377", "Monaco"], ["353", "Irlande"], ["33", "France"], ["41", "Suisse"], ["34", "Espagne"],
  ["32", "Belgique"], ["39", "Italie"], ["44", "Royaume-Uni"], ["49", "Allemagne"],
  ["55", "Brésil"], ["1", "États-Unis"]
];
const LC_ORDER = ["Showroom Little Cabari", "Paris & Île-de-France", "France – Régions", "Monaco", "Suisse", "Belgique", "Espagne", "Italie", "Royaume-Uni", "Irlande", "Allemagne", "États-Unis", "Brésil", "Autres pays"];
const IDF = ["75", "77", "78", "91", "92", "93", "94", "95"];

function lcNorm(s) {
  return (s || "").toString().replace(/\s+/g, " ").trim().toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
}
function lcCountry(item) {
  const phone = (item.dataset.phone || "").replace(/\D/g, "");
  const cp = (item.dataset.postalCode || "").trim();
  if (/^980\d\d$/.test(cp)) return "Monaco";
  for (const [prefix, name] of LC_COUNTRIES) if (phone.startsWith(prefix)) return name;
  return "Autres pays";
}
function lcGroup(item) {
  if (lcNorm(item.dataset.name) === "little cabari") return "Showroom Little Cabari";
  const country = lcCountry(item);
  if (country !== "France") return country;
  const cp = (item.dataset.postalCode || "").trim();
  return IDF.includes(cp.slice(0, 2)) ? "Paris & Île-de-France" : "France – Régions";
}
function lcDistance(lat1, lng1, lat2, lng2) {
  const R = 6371, r = Math.PI / 180;
  const dLat = (lat2 - lat1) * r, dLng = (lng2 - lng1) * r;
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(lat1 * r) * Math.cos(lat2 * r) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(a));
}

function lcInjectStyles() {
  const css = `
  .p_leaflet__group-title{list-style:none;padding:18px 22px 6px;font-size:11px;letter-spacing:.12em;text-transform:uppercase;font-weight:700;border-bottom:1px solid rgba(0,0,0,.12);background:#fff;position:sticky;top:var(--lc-search-h,110px);z-index:1}
  .p_leaflet__group-title span{font-weight:400;opacity:.6;margin-left:6px}
  .lc-near-btn{display:inline-flex;align-items:center;gap:6px;margin-top:10px;padding:8px 12px;border:1px solid currentColor;background:#fff;cursor:pointer;font-size:12px;letter-spacing:.04em}
  .lc-near-btn[disabled]{opacity:.5;cursor:wait}
  .lc-near-msg{display:block;font-size:11px;margin-top:6px}
  .lc-distance{display:inline-block;margin-top:4px;font-size:11px;font-weight:700}
  .p_leaflet__item--showroom{background:rgba(0,0,0,.03)}`;
  const st = document.createElement("style");
  st.textContent = css;
  document.head.appendChild(st);
}

async function initMap() {
  lcInjectStyles();
  const map = new LeafletMap();
  let clickMarker = null;
  const list = document.querySelector(".p_leaflet__list");
  const items = Array.from(document.querySelectorAll(".js-leaflet-map-marker"));
  const searchBox = list.querySelector("search-input");
  const input = document.getElementById("searchStore");
  const counter = document.getElementById("storesCounter");
  const noFound = document.getElementById("noStoresFound");

  await map.load(mapDOM);

  items.forEach(item => {
    item.dataset.group = lcGroup(item);
    item.dataset.country = lcCountry(item);
    if (item.dataset.group === "Showroom Little Cabari") item.classList.add("p_leaflet__item--showroom");
    const marker = map.addMarker(item.dataset.lat, item.dataset.lng, item.dataset.img, item.dataset.name, item.dataset.address, item.dataset.phone);
    item.addEventListener("click", () => {
      items.forEach(i => i.classList.remove("p_leaflet__item--active"));
      item.classList.add("p_leaflet__item--active");
      if (clickMarker !== null) clickMarker.unsetActive();
      marker.setActive();
      map.setView(item.dataset.lat, item.dataset.lng);
      clickMarker = marker;
    });
  });

  /* Construit la liste groupée */
  const headers = {};
  function renderGrouped() {
    list.querySelectorAll(".p_leaflet__group-title").forEach(h => h.remove());
    items.forEach(i => { const d = i.querySelector(".lc-distance"); if (d) d.remove(); });
    const groups = {};
    items.forEach(i => (groups[i.dataset.group] = groups[i.dataset.group] || []).push(i));
    const names = Object.keys(groups).sort((a, b) => {
      const ia = LC_ORDER.indexOf(a), ib = LC_ORDER.indexOf(b);
      return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib) || a.localeCompare(b, "fr");
    });
    names.forEach(g => {
      const h = document.createElement("li");
      h.className = "p_leaflet__group-title";
      h.dataset.groupTitle = g;
      h.innerHTML = `${g}<span>(${groups[g].length})</span>`;
      headers[g] = h;
      list.appendChild(h);
      groups[g]
        .sort((a, b) => lcNorm(a.dataset.city).localeCompare(lcNorm(b.dataset.city), "fr") || lcNorm(a.dataset.name).localeCompare(lcNorm(b.dataset.name), "fr"))
        .forEach(i => list.appendChild(i));
    });
    updateHeaders();
  }

  function updateHeaders() {
    Object.entries(headers).forEach(([g, h]) => {
      const visible = items.filter(i => i.dataset.group === g && i.style.display !== "none").length;
      h.style.display = visible && h.isConnected ? "" : "none";
      const span = h.querySelector("span");
      if (span) span.textContent = `(${visible})`;
    });
  }

  /* Recherche : ville, code postal, nom de boutique ou pays */
  function applySearch() {
    const q = lcNorm(input ? input.value : "");
    let n = 0;
    items.forEach(i => {
      const hay = lcNorm([i.dataset.city, i.dataset.postalCode, i.dataset.name, i.dataset.country].join(" "));
      const ok = !q || hay.includes(q);
      i.style.display = ok ? "" : "none";
      if (ok) n++;
    });
    if (counter) counter.textContent = n;
    if (noFound) noFound.style.display = n ? "none" : "block";
    updateHeaders();
    if (q && n) map.fit(items.filter(i => i.style.display !== "none").map(i => [+i.dataset.lat, +i.dataset.lng]));
    if (!q) map.center();
  }
  if (input) {
    input.placeholder = "Ville, code postal, pays ou boutique";
    input.addEventListener("input", () => setTimeout(applySearch, 0));
  }

  /* Bouton "Autour de moi" */
  if (searchBox && "geolocation" in navigator) {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "lc-near-btn";
    btn.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 8a4 4 0 1 0 0 8a4 4 0 0 0 0-8m8.94 3A8.994 8.994 0 0 0 13 3.06V1h-2v2.06A8.994 8.994 0 0 0 3.06 11H1v2h2.06A8.994 8.994 0 0 0 11 20.94V23h2v-2.06A8.994 8.994 0 0 0 20.94 13H23v-2zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7s7 3.13 7 7s-3.130 7-7 7"/></svg><span>Autour de moi</span>`;
    const msg = document.createElement("span");
    msg.className = "lc-near-msg";
    searchBox.appendChild(btn);
    searchBox.appendChild(msg);
    let nearMode = false;
    let userMarker = null;

    btn.addEventListener("click", () => {
      if (nearMode) {
        nearMode = false;
        btn.querySelector("span").textContent = "Autour de moi";
        msg.textContent = "";
        if (userMarker) { userMarker.remove(); userMarker = null; }
        renderGrouped();
        applySearch();
        return;
      }
      btn.disabled = true;
      msg.textContent = "Localisation en cours…";
      navigator.geolocation.getCurrentPosition(pos => {
        btn.disabled = false;
        nearMode = true;
        btn.querySelector("span").textContent = "Voir toute la liste";
        const { latitude, longitude } = pos.coords;
        if (input) input.value = "";
        items.forEach(i => { i.style.display = ""; i._lcDist = lcDistance(latitude, longitude, +i.dataset.lat, +i.dataset.lng); });
        list.querySelectorAll(".p_leaflet__group-title").forEach(h => h.remove());
        items.slice().sort((a, b) => a._lcDist - b._lcDist).forEach(i => {
          let d = i.querySelector(".lc-distance");
          if (!d) { d = document.createElement("span"); d.className = "lc-distance"; (i.querySelector(".p_leaflet__item-title") || i).appendChild(d); }
          d.textContent = i._lcDist < 10 ? `à ${i._lcDist.toFixed(1).replace(".", ",")} km` : `à ${Math.round(i._lcDist)} km`;
          list.appendChild(i);
        });
        if (counter) counter.textContent = items.length;
        if (noFound) noFound.style.display = "none";
        msg.textContent = "Boutiques classées de la plus proche à la plus éloignée.";
        if (userMarker) userMarker.remove();
        userMarker = L.circleMarker([latitude, longitude], { radius: 7, weight: 2, color: "#1c1b1b", fillColor: "#fff", fillOpacity: 1 }).addTo(map.map);
        const nearest = items.slice().sort((a, b) => a._lcDist - b._lcDist).slice(0, 3).map(i => [+i.dataset.lat, +i.dataset.lng]);
        map.fit(nearest.concat([[latitude, longitude]]));
        list.scrollTop = 0;
      }, () => {
        btn.disabled = false;
        msg.textContent = "Localisation refusée ou indisponible : saisissez votre ville ou code postal.";
      }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 600000 });
    });
  }

  /* Hauteur du bloc de recherche pour coller les titres de groupe dessous */
  if (searchBox) list.style.setProperty("--lc-search-h", searchBox.offsetHeight + "px");

  renderGrouped();
  map.center();
}

document.addEventListener("DOMContentLoaded", function () {
  if (mapDOM !== null) initMap();
});
